import React, { useRef, useState, useEffect } from 'react';
import ReactDOM from "react-dom/client";
import ReactDOMServer from "react-dom/server";

import { LsOpenLayers, } from './ls-openlayers';

import { LayerFacilityVds, LayerFacilityCctv, LayerFacilityVms, LayerFacilityDsrc, LayerFacilitySurf, LayerFacilityCrsr } from './layers/LayerFacility';
import { LayerTrafficLink, LayerTrafficLos, } from './layers/LayerTraffic';
import { PopupFacilityVds, PopupFacilityCctv, PopupFacilityVms, PopupFacilityDsrc, PopupFacilitySurf, PopupFacilityCrsr } from 'pages/components/PopupFacility';
import { PopupTrafficLink, PopupTrafficLos, } from 'pages/components/PopupTraffic';

import ApiService from 'services/ApiService';

import { GisLayerList } from 'map/layers/GisLayerInfo';

const DashboardMap2 = React.forwardRef((props, ref) => {
    const {
    } = props

    const divRef = useRef(null);
    const mapObjRefs = useRef(null);

    React.useImperativeHandle(ref, () => ({
        setLayerVisible,
    }))

    useEffect(() => {
        if (divRef.current) {

            const map = new LsOpenLayers(divRef.current, renderComplete);
            //map.addTileLayer("OpenLayers", window.serviceConfig?.tileUrl);
            map.addTileLayer("OpenLayers", "http://api.vworld.kr/req/wmts/1.0.0/33472E74-6D5A-38C5-9ED1-299F89762FDF/midnight/{z}/{y}/{x}.png");
            map.setProj("EPSG:4326", "EPSG:3857");
            map.setView([127.01164, 37.27800], 14.5, 9, 18);    // 기존값과 같다.

            map.funcMapOpenPopup = mapOpenPopup;
            
            mapObjRefs.current = {
                map,
                popup: ReactDOM.createRoot(document.getElementById("popup")),
            };

            return () => {
                map.setTarget(undefined);
            }
        }
    }, [divRef]);

    useEffect(() => {
        const map = mapObjRefs.current?.map;
        if(map) {
            
        }
    }, []);

    const renderComplete = () => {

        const map = mapObjRefs.current?.map;
        if(map) {
            new LayerTrafficLink(map);
            new LayerTrafficLos(map);

            new LayerFacilityCctv(map);
            new LayerFacilityVds(map);
            new LayerFacilityVms(map);
            new LayerFacilityDsrc(map);
            new LayerFacilitySurf(map);
            new LayerFacilityCrsr(map);           

            setLayerVisible(1, GisLayerList[1]);
        }
    }

    const mapOpenPopup = (olData) => {
        const popup = mapObjRefs.current?.popup;
        if(popup) {
            const data = olData.userData;
            const type = data.get("type");
            switch(type) {
                case "cctv": popup.render(<PopupFacilityCctv data={data} />); break;
                case "vds": popup.render(<PopupFacilityVds data={data} />); break;
                case "vms": popup.render(<PopupFacilityVms data={data} />); break;
                case "surf": popup.render(<PopupFacilitySurf data={data} />); break;
                case "dsrc": popup.render(<PopupFacilityDsrc data={data} />); break;
                case "crsr": popup.render(<PopupFacilityCrsr data={data} />); break;
                //case "link": popup.render(<PopupTrafficLink data={data} />); break;
                //case "los": popup.render(<PopupTrafficLos data={data} />); break;
                default: break;
            }
        }
    }

    const setLayerVisible = (layerIndex, layerList) => {
        mapObjRefs.current?.map.unSelectAll();
        const map = mapObjRefs.current?.map.map;

        const layers = map.getLayers().getArray().filter(x => x.values_.userLayer && x.values_.layerIndex !== layerIndex);
        for(let i = 0; i < layers.length; i++) { 
            layers[i].setVisible(false); 
        }

        for(let i = 0; i < layerList.length; i++) {
            const layer = map.getLayers().getArray().find(x => x.values_.title === layerList[i].layer);
            if(layer) {
                layer.setVisible(layerList[i].checked);
            }            
        }
    }

    return (
        <React.Fragment>
            <div ref={divRef} id="mapContainer" >
                <div id="popup"/>
            </div>            
        </React.Fragment>
    );
});

export default DashboardMap2;